
import Business from '@/components/home/Business'
import Scope from '@/components/home/Scope'
import Qualification from '@/components/home/Qualification'
import Capital from '@/components/home/Capital'
import Cooperation from '@/components/home/Cooperation'
import Footer from '@/components/home/Footer'
export default {
  name: 'Home',
  data() {
    return {
      banner: [{
        type: 1,
        url: '/about'
      }, {
        type: 2,
        url: ''
      }, {
        type: 3,
        url: 'https://account.lbondtech.com/'
      }]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // banner跳转
    goTo(item) {
      switch (item.type) {
      case 1:
        this.$router.push(item.url)
        break
      case 3:
        window.location.href = item.url
        break
      default:
        break;
      }
    }
  },
  components: {
    Business,
    Scope,
    Qualification,
    Capital,
    Cooperation,
    Footer
  }
}
